<template>
  <div style="background-color: #F7F7F8; height: 100vh;">
    <div ref="chat-container" class="chat-container"
         style="min-height: calc(100vh - 100px); max-height: calc(100vh - 100px); overflow: auto; padding-top: 40px">
      <div v-if="chat_history.length" style="padding: 0 20px; display: flex; flex-direction: column; gap: 30px">
        <div v-for="message in chat_history">

          <div v-if="message.role === 'user'" style="display: flex; justify-content: right;">
            <div v-html="message.content"
                 style="background-color: #e9e9e980; padding: 12px; border-radius: 20px; font-size: 15px; font-weight: 600">
            </div>
          </div>

          <div v-if="message.role === 'assistant'" style="display: flex; justify-content: left;">
            <div v-html="message.content" style="padding: 12px; font-size: 15px; font-weight: 600"></div>
          </div>

        </div>

        <div v-if="loading.dots" style="padding: 0 15px">
          <div class="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div style="height: 20px">

        </div>
      </div>
      <div v-else>
        <div style="text-align: center; font-size: 22px; font-weight: bold;">
          Xin chào, tôi là Chatbot của Atosa.
          <br>
          Tôi có thể giúp gì cho bạn, đừng ngại đưa ra câu hỏi nhé.
        </div>
      </div>
    </div>
    <div style="height: 100px; padding: 20px 10px; display: flex; align-items: center; gap: 15px">
      <el-input v-model="chat_message" size="small" style="flex: 1 1 auto" type="textarea" :rows="3"
                :autosize="false" class="chatbot-textarea"
                placeholder="Hãy hỏi tôi bất ký điều gì về Shopee. Ví dụ: hãy hỏi tôi về chỉ số shop của bạn trong ngày hôm nay."
                @keyup.native.enter="m__send_chat()"></el-input>

      <button v-if="!loading.send_chat" style="flex: 0 0 auto;" class="chatbot-send-button" @click="m__send_chat()">
        <svg class="send-icon" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M12 19V5M5 12l7-7 7 7" stroke="white" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      </button>
      <button v-else style="flex: 0 0 auto;" class="chatbot-send-button" @click="loading.fill_message = false">
        <svg width="10" height="10" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
          <rect x="0" y="0" width="40" height="40" rx="8" ry="8" fill="#FFFFFF"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import {pick as _pick} from 'lodash'

export default {
  name: 'chat-bot-component',

  props: {
    shop: null
  },

  data() {
    return {
      chat_id: '0',
      chat_history: [
        // {
        //   role: 'user',
        //   content: 'Xin chào, tôi cần sự trợ giúp của bạn',
        // },
        // {
        //   role: 'assistant',
        //   content: '✅ Đây là kết quả mà tôi đã phân tích được: 📊 **Báo cáo phân tích hiệu suất Shop:** 🔹 **Lưu lượng truy cập (UV):** 348 lượt. → Lưu lượng khách duy trì ổn định (**5.45%**). 🔹 **Tỷ lệ chuyển đổi UV → đơn hàng xác nhận:** 2.01% → Tỷ lệ chuyển đổi ở mức trung bình. Có thể tối ưu thêm trang sản phẩm hoặc remarketing. 🔹 **Doanh thu đã xác nhận (GMV):** 3,418,538₫ → Doanh thu tăng trưởng tốt **96.33%**, chiến lược bán hàng và quảng cáo đang hiệu quả. 🔹 **Giá trị trung bình mỗi đơn hàng:** 488,363₫ → Giá trị đơn hàng giảm **-15.86%**. Đề xuất upsell/cross-sell các sản phẩm liên quan. 📌 **Đề xuất tổng thể:** - Tiếp tục duy trì chiến lược hiện tại. Có thể thử nghiệm các chương trình upsell để tăng GMV.',
        // },
        // {
        //   role: 'assistant',
        //   content: '✅ Đây là kết quả mà tôi đã phân tích được: 📊 **Báo cáo phân tích hiệu suất Shop:** 🔹 **Lưu lượng truy cập (UV):** 348 lượt. → Lưu lượng khách duy trì ổn định (**5.45%**). 🔹 **Tỷ lệ chuyển đổi UV → đơn hàng xác nhận:** 2.01% → Tỷ lệ chuyển đổi ở mức trung bình. Có thể tối ưu thêm trang sản phẩm hoặc remarketing. 🔹 **Doanh thu đã xác nhận (GMV):** 3,418,538₫ → Doanh thu tăng trưởng tốt **96.33%**, chiến lược bán hàng và quảng cáo đang hiệu quả. 🔹 **Giá trị trung bình mỗi đơn hàng:** 488,363₫ → Giá trị đơn hàng giảm **-15.86%**. Đề xuất upsell/cross-sell các sản phẩm liên quan. 📌 **Đề xuất tổng thể:** - Tiếp tục duy trì chiến lược hiện tại. Có thể thử nghiệm các chương trình upsell để tăng GMV.',
        // },
        // {
        //   role: 'assistant',
        //   content: '✅ Đây là kết quả mà tôi đã phân tích được: 📊 **Báo cáo phân tích hiệu suất Shop:** 🔹 **Lưu lượng truy cập (UV):** 348 lượt. → Lưu lượng khách duy trì ổn định (**5.45%**). 🔹 **Tỷ lệ chuyển đổi UV → đơn hàng xác nhận:** 2.01% → Tỷ lệ chuyển đổi ở mức trung bình. Có thể tối ưu thêm trang sản phẩm hoặc remarketing. 🔹 **Doanh thu đã xác nhận (GMV):** 3,418,538₫ → Doanh thu tăng trưởng tốt **96.33%**, chiến lược bán hàng và quảng cáo đang hiệu quả. 🔹 **Giá trị trung bình mỗi đơn hàng:** 488,363₫ → Giá trị đơn hàng giảm **-15.86%**. Đề xuất upsell/cross-sell các sản phẩm liên quan. 📌 **Đề xuất tổng thể:** - Tiếp tục duy trì chiến lược hiện tại. Có thể thử nghiệm các chương trình upsell để tăng GMV.',
        // },
        // {
        //   role: 'assistant',
        //   content: '✅ Đây là kết quả mà tôi đã phân tích được: 📊 **Báo cáo phân tích hiệu suất Shop:** 🔹 **Lưu lượng truy cập (UV):** 348 lượt. → Lưu lượng khách duy trì ổn định (**5.45%**). 🔹 **Tỷ lệ chuyển đổi UV → đơn hàng xác nhận:** 2.01% → Tỷ lệ chuyển đổi ở mức trung bình. Có thể tối ưu thêm trang sản phẩm hoặc remarketing. 🔹 **Doanh thu đã xác nhận (GMV):** 3,418,538₫ → Doanh thu tăng trưởng tốt **96.33%**, chiến lược bán hàng và quảng cáo đang hiệu quả. 🔹 **Giá trị trung bình mỗi đơn hàng:** 488,363₫ → Giá trị đơn hàng giảm **-15.86%**. Đề xuất upsell/cross-sell các sản phẩm liên quan. 📌 **Đề xuất tổng thể:** - Tiếp tục duy trì chiến lược hiện tại. Có thể thử nghiệm các chương trình upsell để tăng GMV.',
        // },
        // {
        //   role: 'assistant',
        //   content: '✅ Đây là kết quả mà tôi đã phân tích được: 📊 **Báo cáo phân tích hiệu suất Shop:** 🔹 **Lưu lượng truy cập (UV):** 348 lượt. → Lưu lượng khách duy trì ổn định (**5.45%**). 🔹 **Tỷ lệ chuyển đổi UV → đơn hàng xác nhận:** 2.01% → Tỷ lệ chuyển đổi ở mức trung bình. Có thể tối ưu thêm trang sản phẩm hoặc remarketing. 🔹 **Doanh thu đã xác nhận (GMV):** 3,418,538₫ → Doanh thu tăng trưởng tốt **96.33%**, chiến lược bán hàng và quảng cáo đang hiệu quả. 🔹 **Giá trị trung bình mỗi đơn hàng:** 488,363₫ → Giá trị đơn hàng giảm **-15.86%**. Đề xuất upsell/cross-sell các sản phẩm liên quan. 📌 **Đề xuất tổng thể:** - Tiếp tục duy trì chiến lược hiện tại. Có thể thử nghiệm các chương trình upsell để tăng GMV.',
        // }
      ],
      chat_message: '',
      loading: {
        send_chat: false,
        dots: false,
        fill_message: false
      }
    }
  },

  async beforeMount() {
    await this.m__get_chat_history()
    this.m__scroll_to_last_message()
  },

  methods: {
    m__replace_character(str) {
      str = str.trim()
      str = str.replace(/\n/g, '<br>')
      str = str.replace(/\t/g, '&emsp;')
      str = str.replace(/\\n/g, '<br>')
      str = str.replace(/\\t/g, '&emsp;')
      return str
    },

    m__scroll_to_last_message() {
      this.$nextTick(() => {
        const container = this.$refs['chat-container']
        container.scrollTop = container.scrollHeight;
      })
    },

    async m__get_chat_history() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/agent/get_chat_history', {
        chat_id: this.chat_id
      }, this.cf())
      this.chat_history = response.body.data.map(i => {
        i.content = this.m__replace_character(i.content)
        return _pick(i, ['role', 'content'])
      })
    },

    async m__push_message(message) {
      this.chat_history.push(message)

      this.$http.post(this.API.URL_API_SRV_2 + '/mipee/agent/update_chat_history', {
        ...message,
        chat_id: this.chat_id,
        shop_id: this.shop.shop_id,
      }, this.cf())
        .catch(console.error)
    },

    async m__send_chat() {
      if (!this.chat_message) return
      if (this.loading.send_chat) return

      this.loading.send_chat = true
      this.loading.dots = true

      // todo: push
      await this.m__push_message({
        role: 'user',
        content: this.chat_message,
      })

      const question = this.chat_message
      this.chat_message = ''
      this.m__scroll_to_last_message()

      try {
        // const message_response = await this.$http.post('http://localhost:8000/chat', {
        const message_response = await this.$http.post('https://agent-api.atosa.asia/chat', {
          shop_id: this.shop.shop_id,
          question: question.trim()
        }, this.cf())
        if (message_response && message_response.body && message_response.body.answer && message_response.body.answer.length) {
          this.loading.dots = false
          message_response.body.answer = this.m__replace_character(message_response.body.answer)

          // todo: update log
          this.$http.post(this.API.URL_API_SRV_2 + '/mipee/agent/update_chat_history', {
            role: 'assistant',
            content: message_response.body.answer,
            chat_id: this.chat_id,
            shop_id: this.shop.shop_id,
          }, this.cf())
            .catch(console.error)

          // todo: push new
          const new_message = {
            role: 'assistant',
            content: '',
          }
          this.chat_history.push(new_message)

          this.loading.fill_message = true
          for (let i = 0; i < message_response.body.answer.length; i++) {
            if (this.loading.fill_message === false) break

            new_message.content += message_response.body.answer[i]
            this.m__scroll_to_last_message()
            await this.sleep(30)
          }
          this.loading.fill_message = false
        } else {
          // todo: push
          await this.m__push_message({
            role: 'assistant',
            content: 'Không có kết quả nào được trả về, vui lòng thử lại sau.',
          })
        }
      } catch (e) {
        // todo: push
        await this.m__push_message({
          role: 'assistant',
          content: 'Có lỗi xảy ra, vui lòng thử lại sau.',
        })
      }

      this.loading.dots = false
      this.loading.send_chat = false
    }
  }
}
</script>

<style>
.chatbot-textarea textarea {
  border-radius: 20px !important;
  background-color: #F7F7F8;
  border: none;
  box-shadow: none;
  resize: none;
  font-size: 13px !important;
  color: #000;
}

.chatbot-textarea textarea:focus {
  border: 1px solid #c0c4cc !important;
}

.chatbot-send-button {
  background-color: #000000;
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.chatbot-send-button:hover {
  background-color: #222222;
}

.send-icon {
  width: 16px;
  height: 16px;
}

.loading-dots {
  display: flex;
  align-items: center;
  gap: 6px;
}

.loading-dots span {
  width: 8px;
  height: 8px;
  background-color: #8e44ad;
  border-radius: 50%;
  opacity: 0.3;
  animation: blink 1.4s infinite;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0%, 80%, 100% {
    opacity: 0.3;
  }
  40% {
    opacity: 1;
  }
}

.chat-container::-webkit-scrollbar-track {
  border-radius: 999px;
}

.chat-container::-webkit-scrollbar-thumb {
  border-radius: 999px;
}
</style>



// WEBPACK FOOTER //
// src/pages/pas/component/component_chatbot.vue